import React from 'react'
import { isMobile } from 'react-device-detect'
import { Dialog } from "@material-ui/core"
import ModificationContext from "../../../../context/ModificationContext"
import PolicyLiabilityExtensionContext from "../../../../context/PolicyLiabilityExtensionContext"
import PolicyManagementContext from "../../../../context/PolicyManagementContext"
import PolicyRenewalContext from "../../../../context/PolicyRenewalContext"
import { ModifyPolicySection } from "./ModifyPolicySection"

export const ModifyPolicyDialog = ({insurance, isRenewal, openModify, closeEditCoverageDetailsDialog}) => {
    return (
        <Dialog
            BackdropProps={{ style: { backgroundColor: 'white', opacity: isMobile ? 1 : 0.64 } }}
            fullWidth
            fullScreen={isMobile}
            open={openModify}
            onClose={closeEditCoverageDetailsDialog}
            PaperProps={{ style: { backgroundColor: 'transparent', borderRadius: '10px' } }}
            maxWidth={'md'}
        >
            <PolicyManagementContext insurance={insurance}>
                <PolicyRenewalContext insuranceId={insurance.insuranceId}>
                    <ModificationContext insurance={insurance}>
                        <PolicyLiabilityExtensionContext insurance={insurance}>
                            <ModifyPolicySection 
                                insurance={insurance} 
                                closeDialog={closeEditCoverageDetailsDialog}
                                isRenewal={isRenewal}
                            />
                        </PolicyLiabilityExtensionContext>
                    </ModificationContext>
                </PolicyRenewalContext>
            </PolicyManagementContext>
        </Dialog>
    )
}